import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';
import { PagehelpmodalComponent } from './pagehelpmodal.component';

@Injectable({
  providedIn: 'root'
})
export class PagehelpmodalService {
 baseproperties: Baseproperties = new Baseproperties(); 
    private baseURL = this.baseproperties.gatewayBaseURL;

  constructor(private httpClient:HttpClient) { }
  gethelpdata(componentid,productid): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/generic/gethelp/${componentid}/${productid}`);
  }

  openhelpmodal(ref,dialogService,title,id,productid?){
   
   ref = dialogService.open(PagehelpmodalComponent, {
      header: title,
      width: '90%',
      height: 'auto',
      data: { componentid:id,productid:productid},
      contentStyle: { overflow: 'hidden' },
      maximizable: false,
      position: 'top'

    })
  }
}
